import { Button } from "antd";
import { useLoaderData } from "react-router-dom";
import { BmcApiService } from "../ApiService/BmcService";
import BmcHeader from "./BmcHeader";
import PoweredByEasebuzz from "./PoweredByEasebuzz";
import "../styles/index.css";

const formatAmount = (val) =>
  Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const BmcStatusPage = () => {
  const txnData = useLoaderData();

  const isSuccess = txnData?.status === "SUCCESS";
  const paymentLinkUrl = txnData?.payment_link_url || "";

  const handlePayAgain = () => {
    if (paymentLinkUrl) window.location.href = paymentLinkUrl;
  };

  const handleDownloadReceipt = () => {
    const base = (process.env.REACT_APP_LAYER_URL || "").replace(/\/$/, "");
    window.open(`${base}/bmc_mumbai/download-receipt/?txn_id=${txnData.transaction_id}`, "_blank");
  };

  return (
    <div className="bmc-wrapper">
      {/* Mobile-only: Powered by Easebuzz at top right */}
      <div className="bmc-mobile-topbar">
        <PoweredByEasebuzz />
      </div>

      <div className="bmc-card">
        <BmcHeader />

        {/* Status body */}
        <div className="bmc-status-body">
          {/* Icon */}
          <div className={`bmc-status-icon ${isSuccess ? "success" : "failure"}`}>
            {isSuccess ? "✓" : "✕"}
          </div>

          {/* Title */}
          <p className={`bmc-status-title ${isSuccess ? "success" : "failure"}`}>
            {isSuccess ? "Payment Successful!" : "Payment Failed!"}
          </p>

          {/* Amount (success only) */}
          {isSuccess && txnData?.amount && (
            <p className="bmc-status-amount">₹ {formatAmount(txnData.amount)}</p>
          )}

          {/* Failure subtitle */}
          {!isSuccess && (
            <p className="bmc-status-subtitle">Oops! We were unable to process your payment.</p>
          )}

          {/* Transaction details */}
          <div className="bmc-status-table">
            <div className="bmc-status-row">
              <div className="bmc-info-label">Transaction ID</div>
              <div className="bmc-info-value">{txnData?.transaction_id || "N/A"}</div>
            </div>
            {isSuccess && (
              <div className="bmc-status-row">
                <div className="bmc-info-label">Total Debited Amount</div>
                <div className="bmc-info-value">₹ {formatAmount(txnData?.net_amount_debit || txnData?.amount || 0)}</div>
              </div>
            )}
            <div className="bmc-status-row">
              <div className="bmc-info-label">Date and Time</div>
              <div className="bmc-info-value">{txnData?.transaction_date || "N/A"}</div>
            </div>
            <div className="bmc-status-row">
              <div className="bmc-info-label">Section Account Code</div>
              <div className="bmc-info-value">{txnData?.property_account_number || "N/A"}</div>
            </div>
          </div>

          {/* Action buttons */}
          <div className="bmc-action-btns">
            {isSuccess ? (
              <>
                <Button
                  className="bmc-btn-outline"
                  onClick={handleDownloadReceipt}
                  disabled={!txnData?.receipt_url}
                  title={!txnData?.receipt_url ? "Receipt is being generated, please wait" : ""}
                >
                  Download Receipt
                </Button>
                {paymentLinkUrl && (
                  <Button className="bmc-btn-primary" onClick={handlePayAgain}>
                    Pay Again
                  </Button>
                )}
              </>
            ) : (
              paymentLinkUrl && (
                <Button className="bmc-btn-primary" onClick={handlePayAgain}>
                  Retry Payment
                </Button>
              )
            )}
          </div>
        </div>

        {/* Mobile-only contact footer inside card */}
        <div className="bmc-footer bmc-status-card-footer">
          For any queries, please contact us at{" "}
          <a href="mailto:contact@mcgm.gov.in">contact@mcgm.gov.in</a>
        </div>
      </div>

      {/* Desktop-only: contact left + Powered by Easebuzz right */}
      <div className="bmc-status-bottom-bar">
        <span>
          For any queries, please contact us at{" "}
          <a href="mailto:contact@mcgm.gov.in">contact@mcgm.gov.in</a>
        </span>
        <PoweredByEasebuzz />
      </div>
    </div>
  );
};

export const fetchTransactionDataBmc = async ({ params }) => {
  const { txn_id } = params;
  const response = await BmcApiService.getTransactionDetails(txn_id);
  if (response?.success) {
    return response;
  }
  throw new Response("Transaction not found", { status: 404 });
};

export default BmcStatusPage;
